export default __webpack_public_path__ + "static/media/Contact_Finder_Sample.41619541.xlsx";